import { render, staticRenderFns } from "./PaymentData.vue?vue&type=template&id=40204447&scoped=true"
import script from "./PaymentData.vue?vue&type=script&lang=js"
export * from "./PaymentData.vue?vue&type=script&lang=js"
import style0 from "./PaymentData.vue?vue&type=style&index=0&id=40204447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40204447",
  null
  
)

export default component.exports